module.exports = __webpack_public_path__ + "static/media/tissues-artwork.eb1fb6bc.jpg";